import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";


@Injectable({
    providedIn: 'root'
})

export class GlobalHycoAwardsService
 {
    constructor(protected http: HttpClient) {
    }

    baseurl = environment.apiBaseUrl;

    getGlobalHycoAwardsReport() {
        return this.http.get<any[]>(this.baseurl + 'H2GlobalHycoAwards');
    }
}